import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './voltarHome.module.scss';
import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const VoltarHome = () => {
    const history = useHistory()
    
    return (
            <div className={styles.backButton} onClick={() => {history.push('/Home')}}>
            <IconButton aria-label="close" className="backModal"><ArrowBack /></IconButton>
            </div>
    )
}

export default VoltarHome;